import React from 'react';
import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const categoryRoutes = ({
  Category,
  AddCategory,
  UpdateCategory,
}: {
  Category: React.ComponentType;
  AddCategory: React.ComponentType;
  UpdateCategory: React.ComponentType;
}) => (
  <Routes>
    <Route path="" element={<Category />} />
    <Route path={ROUTES.MASTER_DATA.CATEGORY.CREATE} element={<AddCategory />} />
    <Route path={ROUTES.MASTER_DATA.CATEGORY.EDIT} element={<UpdateCategory />} />
  </Routes>
);


